export default {
  gift_card_removed: 'Karta podarunkowa usunięta',
  invalid_gift_card: 'Karta podarunkowa jest nieprawidłowa',
  gift_card_applied: 'Karta podarunkowa zastosowana',
};
